<template>
  <div style="height: 100vh; display: flex; flex-direction: column; overflow: hidden; background: #f5f7fa;">
    <!-- 顶部栏：仅在非登录页且用户已登录时显示 -->
    <div
      v-if="!isLoginPage && $store.state.user.user"
      class="top-bar"
      style="height: 60px; flex-shrink: 0; width: 100%; z-index: 10; box-shadow: 0 2px 8px rgba(0,0,0,0.08);"
    >
      <FengMenuTop @toggleDrawer="drawerVisible = true" />
    </div>

    <div class="main-body" style="flex: 1; display: flex; overflow: hidden;">
      <!-- 左侧菜单：仅在非登录页、用户已登录、且桌面端显示 -->
      <div
        class="left-menu"
        style="flex-shrink: 0; width: 220px; overflow: hidden; background: #fff; border-right: 1px solid #e8ecf1;"
        v-if="!isLoginPage && $store.state.config.leftbar && !isMobile && $store.state.user.user"
      >
        <FengMenuLeft />
      </div>

      <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden; min-width: 0; background: #f5f7fa;">
        <!-- 标签页栏 -->
        <div
          v-if="showTabs"
          style="background: white; border-bottom: 1px solid #e4e7ed; padding: 0 16px; flex-shrink: 0; height: 42px; display: flex; align-items: center; 
		  overflow: hidden; width: 100%;"
        >
          <el-tabs
            v-model="activeTabPath"
            type="card"
            closable
            @tab-remove="handleRemoveTab"
            @tab-click="handleTabClick"
            style="width: 100%; min-width: 0; margin-bottom: -1px;"
          >
            <el-tab-pane
              v-for="tab in tabs"
              :key="tab.key"
              :label="tab.title"
              :name="tab.key"
            />
          </el-tabs>
        </div>
        <!-- 页面内容 -->
        <div class="page-content" style="flex: 1; overflow: hidden; padding: 10px;">
          <router-view v-slot="{ Component }">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </div>
      </div>
    </div>

    <!-- 移动端抽屉菜单 -->
    <el-drawer title="菜单" v-model="drawerVisible" direction="ltr" size="240px" :with-header="true">
      <FengMenuLeft @click="drawerVisible = false" />
    </el-drawer>
  </div>
</template>

<script>
if (window.ResizeObserver) {
  const _OriginalRO = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends _OriginalRO {
    constructor(callback) {
      let timer = null;
      const debounced = function () {
        clearTimeout(timer);
        timer = setTimeout(() => callback.apply(this, arguments), 16);
      };
      super(debounced);
    }
  };
}

import { sub } from '../common/event';
import { ElMessage } from 'element-plus';
import { initAllStore } from '../store/storeInits';
import { mapState, mapGetters, mapMutations } from 'vuex';

// ★ 关键修复：在这里引入两个菜单组件
import FengMenuTop from './components/menu/FengMenuTop.vue';
import FengMenuLeft from './components/menu/FengMenuLeft.vue';

export default {
  name: 'App',
  // ★ 关键修复：在这里注册它们
  components: {
    FengMenuTop,
    FengMenuLeft,
  },
  data() {
    return {
      tabs: [],
      activeTabKey: '',
      drawerVisible: false,
      isMobile: window.innerWidth < 768,
    };
  },
  computed: {
    ...mapState('user', ['currentStationId']),
    ...mapGetters('user', ['isSuperAdmin']),
    isLoginPage() { return this.$route.path.includes('/login'); },
    stationList() { return this.$store.state.user.user?.stations || []; },
    showTabs() { return !this.isLoginPage && this.tabs.length > 0; },
    activeTabPath: {
      get() { return this.activeTabKey; },
      set(val) {
        if (this.activeTabKey === val) return;
        this.activeTabKey = val;
        const tab = this.tabs.find((t) => t.key === val);
        if (tab) {
          const target = { path: tab.path, query: tab.query || {} };
          if (this.$route.path !== tab.path || JSON.stringify(this.$route.query) !== JSON.stringify(tab.query || {})) {
            this.$router.push(target);
          }
        }
      },
    },
  },
  watch: {
    '$route'(to) {
      if (to.path.includes('/login')) return;
      this.addTab(to);
    },
  },
  mounted() {
    try {
	  const saved = JSON.parse(localStorage.getItem('openedTabs') || '[]');
	  // ★ 过滤掉以前可能存在的无效数据（如 title 为"未知页面"或者 path 为 '/' 的）
	  this.tabs = Array.isArray(saved) 
		? saved.filter(t => t.path && t.path !== '/' && t.title !== '未知页面') 
		: [];
	  this.saveTabs(); // 重新保存过滤后的干净数据
	} catch (e) {
	  this.tabs = [];
	}

    sub('request_error', (error) => ElMessage({ message: error.message, type: 'error', plain: true }));
    sub('success_message', (msg) => ElMessage({ message: msg, type: 'success', plain: true }));
    sub('error_message', (msg) => ElMessage({ message: msg, type: 'error', plain: true }));
    sub('gologinpage', () => this.$router.push('/login/login'));

    const user = localStorage.getItem('user');
    if (!user) {
      this.$router.push('/login/login');
    } else {
      this.$store.commit('config/setLeftBar', true);
      initAllStore();
      if (!this.$route.path.includes('/login')) {
        const matched = this.tabs.find((t) => t.path === this.$route.path);
        if (matched) this.activeTabKey = matched.key;
        else this.addTab(this.$route);
      }
    }

    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...mapMutations('user', ['setCurrentStationId']),
    handleResize() { this.isMobile = window.innerWidth < 768; },

    getMenuTitle(path, query) {
      const menus = this.$store.getters['menu/filteredList'] || [];
      function findTitle(menuList, targetPath, targetQuery) {
        for (const item of menuList) {
          let isMatch = false;
          if (item.path) {
            isMatch = targetPath === item.path || targetPath.startsWith(item.path + '/');
            if (isMatch && item.query) {
              const itemQ = item.query || {};
              const targetQ = targetQuery || {};
              isMatch = Object.keys(itemQ).every((k) => itemQ[k] == targetQ[k]);
            }
          }
          if (isMatch) return item.name;
          if (item.menus && item.menus.length > 0) {
            const found = findTitle(item.menus, targetPath, targetQuery);
            if (found) return found;
          }
        }
        return null;
      }
      for (const group of menus) {
        if (group.menus && group.menus.length > 0) {
          const found = findTitle(group.menus, path, query);
          if (found) return found;
        }
        if (group.path && (path === group.path || path.startsWith(group.path + '/'))) {
          if (!group.query || JSON.stringify(group.query) === JSON.stringify(query || {})) return group.name;
        }
      }
      return null;
    },

    stableKey(path, query) {
      const q = Object.keys(query || {})
        .sort()
        .map((k) => `${k}=${query[k]}`)
        .join('&');
      return path + (q ? '?' + q : '');
    },

    addTab(route) {
      const path = route.path || route;
	  // ★ 新增：如果是根路径 / 或者无效路径，直接不添加
	  if (path === '/' || !path) return;
      const query = route.query || {};
      const key = this.stableKey(path, query);
      let title = this.getMenuTitle(path, query);
      if (!title && path === '/dashboard/index') title = '工作台';
      if (!title) title = route.meta?.title || path.split('/').filter(Boolean).pop() || '未知页面';

      if (!this.tabs.some((t) => t.key === key)) {
        this.tabs.push({ key, path, title, query, closable: true });
        this.saveTabs();
      }
      this.activeTabKey = key;
    },

    removeTab(key) {
      const index = this.tabs.findIndex((t) => t.key === key);
      if (index === -1) return;
      this.tabs.splice(index, 1);
      this.saveTabs();
      if (this.activeTabKey === key) {
        if (this.tabs.length > 0) {
          const last = this.tabs[this.tabs.length - 1];
          this.activeTabKey = last.key;
          this.$router.push({ path: last.path, query: last.query || {} });
        } else {
          this.$router.push('/dashboard/index');
        }
      }
    },
    handleRemoveTab(key) { this.removeTab(key); },
    handleTabClick() {},
    saveTabs() { localStorage.setItem('openedTabs', JSON.stringify(this.tabs)); },
  },
};
</script>

<style>
/* 全局基础样式 */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
  overflow: hidden;
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
::-webkit-scrollbar-thumb {
  background-color: #c1c9d6;
  border-radius: 4px;
}
::-webkit-scrollbar-track {
  background-color: #f0f2f5;
}

.el-tabs__header {
  margin: 0 !important;
}
.el-tabs--card > .el-tabs__header .el-tabs__item {
  height: 32px;
  line-height: 32px;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom: 2px solid #409eff;
}
.el-menu {
  border-right: none !important;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .top-bar {
    height: 50px !important;
  }
  .page-content {
    padding: 6px !important;
  }
  .el-table__body-wrapper {
    overflow-x: auto;
  }
  .el-table {
    min-width: 600px;
  }
  .el-card__body {
    padding: 12px !important;
  }
  .el-form-item {
    width: 100% !important;
    margin-right: 0 !important;
  }
  .el-form--inline .el-form-item {
    display: block;
    margin-right: 0;
  }
}@media screen and (max-width: 768px) {
  .el-dialog {
    width: 92% !important;
    margin: 5vh auto !important;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
  }
  .el-dialog .el-dialog__body {
    flex: 1;
    overflow-y: auto;
    padding: 20px 16px !important;
  }

  .el-dialog .el-form-item {
    display: flex !important;
    flex-wrap: nowrap !important;
    align-items: center !important;
    margin-bottom: 16px !important;
  }

  /* 核心：标签等宽，内容靠右，星号左移 */
  .el-dialog .el-form-item__label {
    min-width: 80px !important;      /* 根据最长标签调整，如90px */
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center;
    padding-right: 1px !important;
    font-weight: 500;
    font-size: 14px;
    color: #303133;
    white-space: nowrap !important;
    /* 清除默认的文本对齐，由 flex 控制 */
    text-align: right;
  }

  /* 必填项星号：移到最左侧，不占文本空间 */
  .el-dialog .el-form-item.is-required .el-form-item__label::before {
    order: -1 !important;
    margin-right: 1px !important;
    content: '*' !important;
    color: #f56c6c;
    position: static !important;   /* 取消默认的定位干扰 */
    display: inline !important;
  }

  .el-dialog .el-form-item__content {
    flex: 1 !important;
    width: 0 !important;
    margin-left: 0 !important;
  }

  .el-dialog .el-form-item__content .el-input,
  .el-dialog .el-form-item__content .el-select,
  .el-dialog .el-form-item__content .el-input-number,
  .el-dialog .el-form-item__content .el-date-editor,
  .el-dialog .el-form-item__content .el-cascader,
  .el-dialog .el-form-item__content .el-upload {
    width: 100% !important;
  }

  .el-dialog .el-input-number .el-input__wrapper {
    width: 100% !important;
  }

  .el-dialog .el-radio-group,
  .el-dialog .el-checkbox-group {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 8px;
  }
  .el-dialog .el-radio.is-bordered,
  .el-dialog .el-checkbox.is-bordered {
    margin-right: 0 !important;
  }

  .el-dialog__footer {
    display: flex !important;
    gap: 10px !important;
    flex-wrap: wrap !important;
    padding: 10px 16px 16px !important;
    justify-content: center;
  }
  .el-dialog__footer .el-button {
    flex: 1 !important;
    min-width: 80px !important;
    margin: 0 !important;
  }

  .el-dialog .el-card {
    box-shadow: none !important;
    border: none !important;
  }
  .el-dialog .el-card__body {
    padding: 0 !important;
  }

  .el-dialog .avatar-uploader .el-upload {
    width: 80px !important;
    height: 80px !important;
  }
  .el-dialog .avatar-uploader .avatar {
    width: 80px !important;
    height: 80px !important;
  }
}
</style>